import {createFileRoute} from '@tanstack/react-router';
import Header from '../../../Header.tsx';
import FeatureGate from '../../../components/FeatureGate.tsx';
import PlayerEditView from '../../../players/PlayerEditView.tsx';

/**
 * Add a player — the same schema-driven form as edit, with no player_uid.
 *
 * A dedicated route rather than a modal: the full record is a page's worth of fields, and an
 * organizer who lands here from a link should get the whole form, not a dialog over an empty list.
 */
export const Route = createFileRoute('/_app/players/new')({
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <>
            <Header backUrl="/players" />
            <div className="max-w-6xl w-11/12 mx-auto">
                <FeatureGate feature="club_players">
                    <PlayerEditView />
                </FeatureGate>
            </div>
        </>
    );
}
